import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';
import Adds from '../../media/add.png';
import Dialogmessage from '../../dialog';

class Add extends Component {

  state = {
    data: null,
    load: false,
    message: '',
    error: '',
    file: Adds,
    dialogstatus: false,
    display: 'show',
  }

  addInfo() {
    let context = this;
    let partno = this.props.partno;
    let title = document.getElementById('title').value;
    let description = document.getElementById('description').value;
    let long_description = document.getElementById('long_description').value;
    let tamil_name = document.getElementById('tamil_name').value;
    let local_name = document.getElementById('local_name').value;

    if (title == '' || title == null || title == undefined) {
      context.setState({ error: 'Enter title!!!' })
      return;
    }

    if (description == '' || description == null || description == undefined) {
      context.setState({ error: 'Enter description!!!' })
      return;
    }

    if (long_description == '' || long_description == null || long_description == undefined) {
      context.setState({ error: 'Enter long description!!!' })
      return;
    }

    if (tamil_name == '' || tamil_name == null || tamil_name == undefined) {
      context.setState({ error: 'Enter Tamil name!!!' })
      return;
    }

    if (local_name == '' || local_name == null || local_name == undefined) {
      context.setState({ error: 'Enter Local name!!!' })
      return;
    }
    context.setState({
      load: true,
      message: 'Spare Information Adding!!!'
    });
    let data1 = {'partno': partno, 'title': title, 'description': description, 'longDescription': long_description,
                  'localName': local_name, 'tamilName': tamil_name};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addinfo.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.setState({
            load: false,
            display: 'none',
            dialogmessage: 'Your spare part is added successfully!!!',
            dialogstatus: true,
            error: ''
          });
        }
        else {
          context.setState({
            load: false,
            display: 'none',
          })
          alert('Try again');
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  clear() {
    document.getElementById("description").value = "";
    document.getElementById("long_description").value = "";
    document.getElementById("title").value = "";
    document.getElementById("tamil_name").value = "";
    document.getElementById("local_name").value = "";
  }

  closedialog() {
    this.setState({
      dialogstatus: false
    })
  }

  render() {
    let { load, message, dialogmessage, dialogstatus } = this.state;
    let loading,dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (dialogstatus) {
      dialogs = (<Dialogmessage message={dialogmessage} closedialog={this.closedialog.bind(this)} dialogstatus={dialogstatus} />)
    }
    return (
      <div style={{padding: '1%'}}>
        <Card fluid>
        <Grid style={{padding: '1%'}}>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                Title<br/>
                <Input id='title' focus placeholder='Title'  value={this.props.title}
                style={{ borderColor: '#5A9CBB' }} fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                Description<br/>
                <Form><TextArea id='description' autoHeight
                placeholder='Description' fluid
                style={{ minHeight: 100, borderColor: '#5A9CBB' }} /></Form>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                Long Descriptidon<br/>
                <Form><TextArea id='long_description' autoHeight placeholder='Long Description' fluid style={{ minHeight: 100, borderColor: '#5A9CBB' }} /></Form>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Tamil Name<br/>
                <Input id='tamil_name' focus placeholder='Tamil Name' style={{ borderColor: '#5A9CBB' }} fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Local Name<br/>
                <Input id='local_name' focus placeholder='Local Name' style={{ borderColor: '#5A9CBB' }} fluid />
              </Grid.Column>
            </Grid>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <center><div style={{color: 'red', fontSize: 13, fontWeight: 'bold'}}>{this.state.error}</div></center>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8} style={{display: this.state.display}}>
            <Button color='red' fluid onClick={this.clear.bind(this)}>Clear</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8} style={{display: this.state.display}}>
            <Button fluid positive onClick={this.addInfo.bind(this)}>
            Save
            </Button>
          </Grid.Column>
        </Grid>
        </Card>
        {dialogs}
        {loading}
      </div>
    );
  }
}

export default Add;
